// extracted by mini-css-extract-plugin
export var button = "_i-0";
export var buttonContent = "_i-e";
export var buttonGroup = "_i-c";
export var dontRestrainIconWidth = "_i-a";
export var dropdownButton = "_i-b";
export var iconContainer = "_i-9";
export var lg = "_i-4";
export var md = "_i-3";
export var pending = "_i-f";
export var sm = "_i-2";
export var spinner = "_i-d";
export var squared = "_i-8";
export var wrapText = "_i-g";
export var xl = "_i-5";
export var xs = "_i-1";
export var xxl = "_i-6";
export var xxxl = "_i-7";